import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideClipboardCheck } from "lucide-react";
import WorkSummaryCard from "./components/WorkSummaryCard";
import WorkStatusGrid from "./components/WorkStatusGrid";
import MonthlyWorkHoursGraph from "./components/MonthlyWorkHoursGraph";
import RecentAttendanceList from "./components/RecentAttendanceList";
import { getUserAttendanceStats } from "../../../../redux/timecard/timeCardState";

const EmployeeAttendance = ( props) => {
  const { user, workStats, requesting, fetchWorkStats } = props;

  useEffect(() => {
    if (!user) return;

      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
        .toISOString()
        .split("T")[0];
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
        .toISOString()
        .split("T")[0];

      fetchWorkStats({ userId: user.id, from: firstDay, to: lastDay });
      }, [user, fetchWorkStats]
    );

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-6 rounded-xl border-2 border-blue-200 dark:border-blue-700 bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-950/30 dark:to-cyan-950/30 p-4">
        <div className="flex items-center gap-3">
          <span className="p-3 rounded-full bg-blue-100 dark:bg-blue-900/50 text-blue-600">
            <LucideClipboardCheck />
          </span>
          <div>
            <h3 className="text-sm font-semibold">Standard Working Hours</h3>
            <p className="text-xs text-slate-700">
              7:00 AM - 4:00 PM (9 hours total, including 1 hour lunch break)
            </p>
          </div>
        </div>
      </div>

      <WorkSummaryCard/>

      <HeaderComponent
        title="Detailed Attendance Breakdown"
        labelIcon={<LucideClipboardCheck size={20} />}
        description="Comprehensive view of your attendance and work hours"
        bgcolor="border-b bg-slate-50"
      >
        <div className="space-y-5">
          <WorkStatusGrid workStats={workStats} requesting={requesting} />
          <MonthlyWorkHoursGraph workStats={workStats} />
          <RecentAttendanceList/>
        </div>
      </HeaderComponent>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  workStats: state.timeCard.workStats.data,
  requesting: state.timeCard.workStats.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  fetchWorkStats: (payload) => dispatch(getUserAttendanceStats(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAttendance);
